import { CheckCircle, Gift } from "lucide-react";

/**
 * Step 9 of the instant-quote funnel — terminal "thank you" view shown
 * after the customer either books an appointment OR clicks "I have a
 * question" (handled by the `hasQuestion` flag). Renders one of two
 * copy variants and optionally echoes the requested appointment slot.
 */
export default function SuccessStep({ firstName, hasQuestion, selectedSlot, screenCheckPreference }) {
  const includesScreenCheck =
    screenCheckPreference === "whole_home_check" || screenCheckPreference === "quick_check";
  const screenCheckLabel =
    screenCheckPreference === "whole_home_check" ? "Whole-Home Screen Check" : "Quick Screen Check";

  return (
    <div className="text-center py-8 space-y-6" data-testid="step-success">
      <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto">
        <CheckCircle className="w-10 h-10 text-[#207024]" />
      </div>

      {hasQuestion ? (
        <>
          <h1 className="text-2xl font-bold text-zinc-900">We Got Your Message!</h1>
          <p className="text-zinc-600 max-w-sm mx-auto">
            Thanks, {firstName}! We&apos;ll reach out shortly to answer your pricing question and get you scheduled.
          </p>
        </>
      ) : (
        <>
          <h1 className="text-2xl font-bold text-zinc-900">You&apos;re All Set!</h1>
          <p className="text-zinc-600 max-w-sm mx-auto">
            Thanks, {firstName}! Your appointment request has been submitted.
            We&apos;ll confirm your appointment within 24 hours.
          </p>
          {selectedSlot && (
            <div className="bg-green-50 rounded-xl p-4 border-2 border-green-200 inline-block">
              <p className="text-green-800 font-semibold">
                Requested: {selectedSlot.label} on {selectedSlot.date}
              </p>
            </div>
          )}
          {/* Free screen-check confirmation — only when the customer opted
              in during the V3 funnel step. Reinforces the gift so they
              remember it's happening and don't feel surprised at the visit. */}
          {includesScreenCheck && (
            <div
              className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#207024] text-white text-sm font-semibold shadow-sm"
              data-testid="success-screen-check-badge"
            >
              <Gift className="w-4 h-4" />
              Includes: Free {screenCheckLabel}
            </div>
          )}
        </>
      )}

      <p className="text-sm text-zinc-500">
        Questions? Call us at <a href="tel:8555004416" className="text-[#207024] font-semibold">(855) 500-4416</a>
      </p>
    </div>
  );
}
